import { throwError } from "@/lib/throwError";
import { axiosConfig } from "@/services/axiosConfig";
import {
  SMSConfiguration,
  SMSConfigurationList,
  SMSConfigurationPayload,
} from "@/utils/types/smsConfiguration";

const basePath = "/tenant-core/tenant-sms-config";

class SMSConfigurationService {
  getAllSMSConfigurations = async ({
    page,
    pageSize,
  }: {
    page: number;
    pageSize: number;
  }): Promise<SMSConfigurationList> => {
    const response = await axiosConfig.get(`${basePath}/`, {
      params: {
        page,
        page_size: pageSize,
      },
    });
    return response.data;
  };

  getSMSConfigurationById = async (id: string): Promise<SMSConfiguration> => {
    if (!id) {
      throwError("ID is required", "SMSConfigurationService");
    }
    const response = await axiosConfig.get(`${basePath}/${id}/`);
    return response.data;
  };

  createSMSConfiguration = async (
    payload: SMSConfigurationPayload
  ): Promise<any> => {
    if (!payload) {
      throwError("Payload is required", "SMSConfigurationService");
    }
    const response = await axiosConfig.post(`${basePath}/`, payload);
    return response.data;
  };

  updateSMSConfiguration = async (
    id: string,
    payload: SMSConfigurationPayload
  ): Promise<any> => {
    if (!id || !payload) {
      throwError("ID and payload are required", "SMSConfigurationService");
    }
    const response = await axiosConfig.put(`${basePath}/${id}/`, payload);
    return response.data;
  };

  deleteSMSConfiguration = async (id: string): Promise<void> => {
    if (!id) {
      throwError("ID is required", "SMSConfigurationService");
    }
    await axiosConfig.delete(`${basePath}/${id}/`);
  };
}

const instance = new SMSConfigurationService();
export default instance;
